import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "16px",
  gap: "16px",
});

export const TitleWrap = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const TitleRow = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  gap: "16px",
});

export const PageTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const MetaContainer = styled(Box)({
  display: "flex",
  gap: "8px",
  alignItems: "center",
});

export const MetaItem = styled(Typography)({
  fontFamily: "Nunito",
  fontSize: "16px",
  color: colors.text.secondary,
});

export const HeaderActions = styled(Box)({
  display: "flex",
  gap: "16px",
  whiteSpace: "nowrap",
  "& button": {
    gap: "8px",
  },
});
